export const firebaseConfig = {
  apiKey: 'AIzaSyD68lGpaF6YqdCLFjUf4XXLVn-5E7HUObI',
  authDomain: 'ali-forest-carbon-dev.firebaseapp.com',
  projectId: 'ali-forest-carbon-dev',
  storageBucket: 'ali-forest-carbon-dev.appspot.com',
  messagingSenderId: '1058821936729',
  appId: '1:1058821936729:web:e8999bb54caf04a63f4348',
};

export default firebaseConfig;
